import { useEffect } from "react";
import { useAuth } from "helpers/authContext";
import { clearUploadState, getUploadState } from "helpers/UploadState";
import { getVideo } from "helpers/UploadDB";
import { upload_video_chunked } from "services/db-service";
import { uploadManager } from "helpers/UploadContext";

export default function UploadResume(){

  const { user } = useAuth();

  useEffect(()=>{

    if(!user) return;

    async function resumeUpload(){ 
      const state = getUploadState(); 
      if(!state || !state.uploadId) return; 
      const file = await getVideo(state.uploadId);

      if(!file){
        clearUploadState(); 
        return;
      } 
      console.log("Resuming upload...");
      uploadManager.start(state.uploadId, { status:"uploading" }); 
      upload_video_chunked(
        file,
        user,
        ()=>{},
        ()=>{},
        ()=>{},
        ()=>{},
        state.uploadId,
        state.uploadedChunks
      ).catch((error: any) => {
        uploadManager.emit(state.uploadId, {
          paused: true,
          error: error.response?.data?.message || error.message || "Unable to resume upload."
        });
      });

    }

    resumeUpload().catch(() => {
      console.warn("Unable to read the saved upload. Reselect the video to retry.");
    });

  },[user]);

  return null;

}